import "./home.css";

import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ArrowForward } from "@mui/icons-material";

import { HOME_SECTIONS, PAGE_ROUTES } from "../../utils/stateTypes";
import { SERVICES } from "../../data/services";
import Reveal from "../general/Reveal";
import ContactSection from "./ContactSection";

const CREDENTIALS = [
  "Served articles at Van Zyl Le Roux & Hurter Inc. Pretoria (2002).",
  "Practiced as professional assistant at Tim Du Toit & Co (2003-2005).",
  "Practiced as litigation attorney and in general law in various Provinces in South Africa and then took an interest in Conveyancing and Notarial services in 2007.",
  "She has since been practicing in this speciality field.",
];

const Home = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Janine Botha Attorneys | Notary &amp; Conveyancing in Centurion</title>
      </Helmet>

      {/* ------------------------------ HERO ------------------------------ */}
      <section className={"hero"}>
        <div className={"container hero-grid"}>
          <div className={"hero-text"}>
            <h1 className={"h-display hero-words"}>
              <span>Trusted</span>
              <span>Efficient</span>
              <span className={"script"}>Personal</span>
            </h1>
            <Link
              to={HOME_SECTIONS.CONTACT}
              className={"btn-pill"}
            >
              Get in touch
              <ArrowForward />
            </Link>
            <p className={"lead hero-tagline"}>Notary &amp; Conveyancing Services with a Personal Touch.</p>
          </div>
          <img
            className={"hero-image"}
            src={"/images/hero-illustration.webp"}
            alt={"Illustration of an attorney meeting with clients beneath the scales of justice"}
            width={1400}
            height={862}
          />
        </div>
      </section>

      {/* ------------------------------ ABOUT ------------------------------ */}
      <section
        id={"about"}
        className={"section bg-green about"}
      >
        <div className={"container"}>
          <Reveal>
            <h2 className={"h-section"}>
              {"Meet "}
              <span className={"script script-white"}>janine</span>
              {", your legal ally"}
            </h2>
          </Reveal>
          <div className={"about-grid"}>
            <Reveal className={"about-text"}>
              <p>With more than 15 years of experience in the speciality fields of Conveyancing and Notarial service, Janine Botha Attorneys Inc. provides expert legal services with a client-centered approach. Based in Centurion, Gauteng, Janine Botha is dedicated to efficiency, responsiveness and accessibility. She ensures a quick turnaround time on Notary Public services and property Conveyancing, always prioritising strong client relationships and personalised service. Going the extra mile isn’t just a promise—it’s the foundation of her practice.</p>
              <h3 className={"about-credentials"}>
                LL.B (University of Pretoria) cum laude
                <br />
                Janine is an admitted Attorney (2003), Notary (2004) and Conveyancer (2008).
              </h3>
              <ul className={"about-history"}>
                {CREDENTIALS.map((item) => <li key={item}>{item}</li>)}
              </ul>
            </Reveal>
            <Reveal
              className={"about-photo"}
              delay={0.15}
            >
              <img
                src={"/images/janine.webp"}
                alt={"Janine Botha"}
                width={1100}
                height={911}
                loading={"lazy"}
              />
            </Reveal>
          </div>
        </div>
      </section>

      {/* ------------------------------ STATEMENT ------------------------------ */}
      <section className={"section statement"}>
        <Reveal className={"container-narrow"}>
          <p>
            {"Whether navigating complex "}
            <span className={"script script-green"}>property transactions</span>
            {", providing personalised "}
            <span className={"script script-green"}>notarial services</span>
            {" tailored to your unique legal needs or securing your estate for future generations, we are committed to delivering expert guidance with a client-focused approach. Your peace of mind is our "}
            <span className={"script script-green"}>priority</span>
          </p>
        </Reveal>
      </section>

      {/* ------------------------------ SERVICES ------------------------------ */}
      <section className={"section specialise"}>
        <div className={"container"}>
          <Reveal>
            <h2 className={"h-section specialise-heading"}>
              {"We "}
              <span className={"script script-green"}>Specialise</span>
              {" in"}
            </h2>
          </Reveal>
          <div className={"specialise-grid"}>
            {SERVICES.map((service, i) => (
              <Reveal
                key={service.id}
                className={"specialise-card"}
                delay={i * 0.08}
              >
                <img
                  src={service.icon}
                  alt={""}
                  width={77}
                  height={77}
                  loading={"lazy"}
                />
                <h3>{service.cardTitle}</h3>
                <p>{service.summary}</p>
                <Link
                  to={`${PAGE_ROUTES.SERVICES}#${service.id}`}
                  className={"btn-pill"}
                  aria-label={`Learn more about ${service.cardTitle}`}
                >
                  Learn More
                  <ArrowForward />
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <ContactSection />
    </React.Fragment>
  );
};

export default Home;
